<template>
  <v-dialog v-model="modelPremio" width="400px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card v-if="voucher != null">
      <v-card-text class="pa-8" >
        <div class="parabens text-center">
          <div>
            <span v-if="getUserInfo">Parabéns<br>{{ getUserInfo.name.split(" ")[0] }}</span>
            <span v-else>Parabéns</span>
          </div>
          <img src="@/assets/images/ribbon.png">
        </div>
        <div class="mt-3 text-xsmall mt-5 text-center" v-if="getConfig.storeConfig">{{ getConfig.storeConfig.store_name }} PREMIA VOCÊ COM OS BRINDES:</div>
        <div class="mt-3 text-xsmall mt-5 text-center" v-else>NÓS PREMIAMOS VOCÊ COM OS BRINDES:</div>
        <div class="mt-3 text-center text-color-black"><b>{{ voucher.name }}</b></div>
        <div class="mt-3 text-center text-color-black">
            <v-icon icon="mdi-star" class="mr-1"></v-icon>
            <v-icon icon="mdi-star" class="mr-1"></v-icon>
            <v-icon icon="mdi-star" class="mr-1"></v-icon>
            <v-icon icon="mdi-star" class="mr-1"></v-icon>
            <v-icon icon="mdi-star" class="mr-1"></v-icon>
            <v-icon icon="mdi-star"></v-icon>
        </div>
        <div class="mt-3 text-center text-xsmall text-color-black font-weight-bold">{{ voucher.description }}</div>
        <div class="mt-4 text-center text-color-black codigo-premio" v-if="voucher.code != ''"><span>{{ voucher.code }}</span></div>
        <div class="mt-4 text-xsmall text-center">A PREMIAÇÃO É VÁLIDA ATÉ O DIA:</div>
        <div class="mt-3 text-center text-color-black font-weight-bold">{{ $formatDate(voucher.expiration) }} {{ $formatTime(voucher.expiration).replace(":", "h") }}</div>
        <div class="mt-3 text-xsmall text-center">APRESENTAR O CÓDIGO DO VOUCHER NO BALÇÃO DE ATENDIMENTO PARA RETIRAR SEU BRINDE.</div>
        <div class="mt-3 text-xsmall text-center">A PREMIAÇÃO É ÚNICA E INSTRANSFERÍVEL. APÓS A APRESENTAÇÃO DO VOUCHER O MESMO SERÁ EXCLUÍDO AUTOMATICAMENTE.</div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'DialogPremio',
  data(){
    return {
      modelPremio: false
    }
  },
  props: {
    voucher: {
      type: Object,
      default: null
    },
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  watch: {
    model() {
      this.modelPremio = this.model
    }
  },
  computed: {
    ...mapGetters('main', {
      getConfig: 'getConfig'
    }),
    ...mapGetters('user', {
      getUserInfo: 'getUserInfo'
    }),
  }
}
</script>